import { ANIMATE_DELAY, ANIMATED_STYLE } from "src/libs/interfaces/animated"; 
import { LANDING_TYPE_CONTENT } from "../interfaces";
import { getID } from "src/libs/utilities";

export default function table(): any[] {
    return [
        {
          "id": getID("table"),
          "type": LANDING_TYPE_CONTENT.TABLE,
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "data": [
            {
              "Набранные баллы": "50 и более баллов",
              "Отметка в аттестат": "5 (отлично)"
            },
            {
              "Набранные баллы": "40 - 49 баллов",
              "Отметка в аттестат": "4 (хорошо)"
            },
            {
              "Набранные баллы": "23 - 39 баллов",
              "Отметка в аттестат": "3 (удовлетворительно)"
            },
            {
              "Набранные баллы": "0 - 22 балла",
              "Отметка в аттестат": "2 (неудовлетворительно)"
            }
          ],
          defaultTitle: "Простая светлая таблица"
        },
        {
          "id": getID("table"),
          "type": LANDING_TYPE_CONTENT.TABLE,
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": "light",
          "hover": true,
          "striped": true,
          "bordered": true,
          "data": [
            {
              "Набранные баллы": "50 и более баллов",
              "Отметка в аттестат": "5 (отлично)"
            },
            {
              "Набранные баллы": "40 - 49 баллов",
              "Отметка в аттестат": "4 (хорошо)"
            },
            {
              "Набранные баллы": "23 - 39 баллов",
              "Отметка в аттестат": "3 (удовлетворительно)"
            },
            {
              "Набранные баллы": "0 - 22 балла",
              "Отметка в аттестат": "2 (неудовлетворительно)"
            }
          ],
          "defaultTitle": "Светлая оконтуренная таблица-зебра"
        },
        {
          "id": getID("table"),
          "type": LANDING_TYPE_CONTENT.TABLE,
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": "dark",
          "data": [
            {
              "Набранные баллы": "50 и более баллов",
              "Отметка в аттестат": "5 (отлично)"
            },
            {
              "Набранные баллы": "40 - 49 баллов",
              "Отметка в аттестат": "4 (хорошо)"
            },
            {
              "Набранные баллы": "23 - 39 баллов",
              "Отметка в аттестат": "3 (удовлетворительно)"
            },
            {
              "Набранные баллы": "0 - 22 балла",
              "Отметка в аттестат": "2 (неудовлетворительно)"
            }
          ],
          "defaultTitle": "Контрасная таблица"
        },
        {
          "id": getID("table"),
          "type": LANDING_TYPE_CONTENT.TABLE,
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": "success",
          "data": [
            {
              "Набранные баллы": "50 и более баллов",
              "Отметка в аттестат": "5 (отлично)"
            },
            {
              "Набранные баллы": "40 - 49 баллов",
              "Отметка в аттестат": "4 (хорошо)"
            },
            {
              "Набранные баллы": "23 - 39 баллов",
              "Отметка в аттестат": "3 (удовлетворительно)"
            },
            {
              "Набранные баллы": "0 - 22 балла",
              "Отметка в аттестат": "2 (неудовлетворительно)"
            }
          ],
          "defaultTitle": "Зеленая таблица"
        },
        {
          "id": getID("table"),
          "type": LANDING_TYPE_CONTENT.TABLE,
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": "light",
          "size": "small",
          "hover": true,
          "striped": true,
          "bordered": false,
          "data": [
            {
              "Набранные баллы": "50 и более баллов",
              "Отметка в аттестат": "5 (отлично)"
            },
            {
              "Набранные баллы": "40 - 49 баллов",
              "Отметка в аттестат": "4 (хорошо)"
            },
            {
              "Набранные баллы": "23 - 39 баллов",
              "Отметка в аттестат": "3 (удовлетворительно)"
            },
            {
              "Набранные баллы": "0 - 22 балла",
              "Отметка в аттестат": "2 (неудовлетворительно)"
            }
          ],
          "defaultTitle": "Узкая таблица"
        },
         {
          "id": getID("table"),
          "type": LANDING_TYPE_CONTENT.TABLE,
          "animated": ANIMATED_STYLE.FADE_IN_UP,
          "animated_delay": ANIMATE_DELAY.WATERFALL,
          "design_type": "light",
          "size": "large",
          "hover": true,
          "striped": true,
          "bordered": false,
          "data": [
            {
              "Набранные баллы": "50 и более баллов",
              "Отметка в аттестат": "5 (отлично)"
            },
            {
              "Набранные баллы": "40 - 49 баллов",
              "Отметка в аттестат": "4 (хорошо)"
            },
            {
              "Набранные баллы": "23 - 39 баллов",
              "Отметка в аттестат": "3 (удовлетворительно)"
            },
            {
              "Набранные баллы": "0 - 22 балла",
              "Отметка в аттестат": "2 (неудовлетворительно)"
            }
          ],
          "defaultTitle": "Большая таблица"
        },
    ]
}